import Calls from '../../assets/enterprise-icon/calls.svg';
import Sla from '../../assets/enterprise-icon/sla.svg';
import Implementation from '../../assets/enterprise-icon/implementation.svg';
import CallsPerSecond from '../../assets/enterprise-icon/calls-per-second.svg';
import Multitenant from '../../assets/enterprise-icon/multitenant.svg';
import Support from '../../assets/enterprise-icon/support.svg';
import Price from '../../assets/enterprise-icon/price.svg';
import Accountmanager from '../../assets/enterprise-icon/accountmanager.svg';

const enterpriseList = [{
  title: '250.000+ calls',
  icon: Calls
}, {
  title: 'SLA',
  icon: Sla
}, {
  title: 'Advies bij implementatie',
  icon: Implementation
}, {
  title: '25+ calls per seconde',
  icon: CallsPerSecond
}, {
  title: 'Multitenant',
  icon: Multitenant
}, {
  title: '24/7 support',
  icon: Support
}, {
  title: 'Prijs op maat',
  icon: Price
}, {
  title: 'Dedicated accountmanager',
  icon: Accountmanager
}];

export default enterpriseList;
